// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ProjectStatus } from "./ProjectStatus";
import {
  ProjectStatusFromJSON,
  ProjectStatusFromJSONTyped,
  ProjectStatusToJSON,
  ProjectStatusToJSONTyped,
} from "./ProjectStatus";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";

/**
 *
 * @export
 * @interface ProjectUpdate
 */
export interface ProjectUpdate {
  /**
   *
   */
  status?: ProjectStatus | null;
  /**
   *
   */
  code?: string | null;
  /**
   *
   */
  name?: string | null;
  /**
   *
   */
  location?: Point | null;
  /**
   *
   */
  locationName?: string | null;
  /**
   *
   */
  description?: string | null;
  /**
   *
   */
  showOnboarding?: boolean | null;
}

/**
 * Check if a given object implements the ProjectUpdate interface.
 */
export function instanceOfProjectUpdate(value: object): value is ProjectUpdate {
  return true;
}

export function ProjectUpdateFromJSON(json: any): ProjectUpdate {
  return ProjectUpdateFromJSONTyped(json, false);
}

export function ProjectUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectUpdate {
  if (json == null) {
    return json;
  }
  return {
    status:
      json["status"] === undefined
        ? undefined
        : json["status"] === null
        ? null
        : ProjectStatusFromJSON(json["status"]),
    code: json["code"] === undefined ? undefined : json["code"] === null ? null : json["code"],
    name: json["name"] === undefined ? undefined : json["name"] === null ? null : json["name"],
    location:
      json["location"] === undefined
        ? undefined
        : json["location"] === null
        ? null
        : PointFromJSON(json["location"]),
    locationName:
      json["location_name"] === undefined
        ? undefined
        : json["location_name"] === null
        ? null
        : json["location_name"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
    showOnboarding:
      json["show_onboarding"] === undefined
        ? undefined
        : json["show_onboarding"] === null
        ? null
        : json["show_onboarding"],
  };
}

export function ProjectUpdateToJSON(json: any): ProjectUpdate {
  return ProjectUpdateToJSONTyped(json, false);
}

export function ProjectUpdateToJSONTyped(
  value?: ProjectUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    status: ProjectStatusToJSON(value["status"]),
    code: value["code"],
    name: value["name"],
    location: PointToJSON(value["location"]),
    location_name: value["locationName"],
    description: value["description"],
    show_onboarding: value["showOnboarding"],
  };
}
